import { ContentItemType } from "../../backend-api/types"

export const getContentTypeDisplayValue = (contentType: ContentItemType) => {
  return contentType.toString().split('_').map(i => i.charAt(0).toUpperCase() + i.slice(1)).join(' ');
}